// removed by extract-text-webpack-plugin
module.exports = {"dashboardContainer":"Dashboard__dashboardContainer___OVq1V"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Dashboard/Dashboard.scss
// module id = 1574
// module chunks = 0